import React, { Component } from 'react';
import { FontAwesome } from 'components/ui';
import './styles/FileInput.scss';

export class FileInput extends Component {

  state = {
    text: 'Choose a file'
  }

  fileSelected = () => {
    var files = this.props.inputRef.current.files;
    
    this.setState({
      text: files.length > 0 ? files[0].name : 'Choose a file'
    });
  }

  render(){
    const { inputRef, className } = this.props;
    return (
      <div className='FileInput'>
        <input type="file" id="file" accept=".xls,.xlsx" ref={ inputRef } 
          className={ className } onChange={ this.fileSelected }/>
        <label htmlFor="file">
          <FontAwesome icon='upload'/>&nbsp;
          <strong>{this.state.text}</strong>
          {/* <span className="box__dragndrop"> or drag it here</span>. */}
        </label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/FileInput.jsx